import type React from 'react';

import { badge, badgeSection } from '@mage-ui/styled-system/recipes';
import { Badge as MantineBadge } from '@mantine/core';

export type BadgeProps = {
  classNames?: {
    root?: string;
    section?: string;
  };
  children?: React.ReactNode;
  endSlot?: React.ReactNode;
  startSlot?: React.ReactNode;
};

export const Badge = ({
  children,
  endSlot,
  startSlot,
  classNames,
  ...props
}: BadgeProps) => {
  return (
    <MantineBadge
      classNames={{
        root: classNames?.root ?? badge(),
        section: classNames?.section ?? badgeSection(),
      }}
      leftSection={startSlot}
      rightSection={endSlot}
      {...props}
    >
      {children}
    </MantineBadge>
  );
};
